import { Box, Grid, Button, InputBase } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import FormDialog from "components/modal";
import moment from "moment";
import ExpenseTypesForm from "../forms/expenseTypesForm";
import ExpenseTransactionsForm from "../forms/expenseTransactionsForm";
import {requester} from "api/pesabackend";
import { setRefreshCount } from "state/authSlice";
import { useGetPaymentTypesList } from "api/hooks/billing";
import { useGetExpenseTypesList } from "api/hooks/accounting";


export default function ExpenseTypesTable () {
  
  const dispatch = useDispatch();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const {paymentTypesList} = useGetPaymentTypesList(1, business_branch_id);
  const {expenseTypesList, isLoadingExpenseTypesList, setNewExpenseType} = useGetExpenseTypesList(1, business_branch_id)

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [expenseId, setExpenseId] = useState("");
  const [paymentTypes, setPaymentTypes] = useState([] );
  const [paymentId, setPaymentId] = useState("");
  const [transactionDate, setTransactionDate] = useState(moment().format('YYYY-MM-DD'));
  const [isSubmittingExpenseType, setIsSubmittingExpenseType] = useState(false)
  const [isSubmittingExpenseTransaction, setIsSubmittingExpenseTransaction] = useState(false);
  const [open, setOpen] = useState(false);
  const [openExpenseRecording, setOpenExpenseRecording] = useState(false);
  const[searchContent, setSearchContent] = useState("")

  const handleChangeName = (e) => {
    setName(e.target.value)
  }

  const handleChangeDescription = (e) => {
    setDescription(e.target.value)
  }


  const handleChangePaymentId = (e) => {
    setPaymentId(e.target.value);
  };

  const handleChangeAmount = (e) => {
    setAmount(e.target.value);
  };

  const handleChangeTransactionDate = (e) => {
    setTransactionDate(e.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    // setModal("");
    setOpen(false);
  };

  const handleClickOpenExpenseRecording = (expenseId) => {
    setExpenseId(expenseId);
    setPaymentTypes(paymentTypesList);
    setOpenExpenseRecording(true);
  };

  const handleCloseExpenseRecording = () => {
    // setModal("");
    setOpenExpenseRecording(false);
  };

  const saveExpenseType = async () => {
    setIsSubmittingExpenseType(true)
    const submitData = {
      "related_business": 1,
      "related_business_branch": business_branch_id,
      "expense_type_name": name,
      "expense_type_description": description,
    }
    try {
      await requester.post("/accounting/expense_types", submitData)
      setIsSubmittingExpenseType(false)
      dispatch(setRefreshCount());
      setNewExpenseType(true);
      setOpen(false)
    }catch (err){
        setIsSubmittingExpenseType(false)
    }
  };

  const saveExpenseTransaction = async () => {
    setIsSubmittingExpenseTransaction(true)
    const submitData = {
      "expense_id": expenseId,
      "payment_type_id": paymentId,
      "amount": amount,
      "date": transactionDate,
    }
    try {
      await requester.post("/accounting/expense_types/transaction", submitData)
      setIsSubmittingExpenseTransaction(false)
      dispatch(setRefreshCount())
      setOpenExpenseRecording(false)
    }catch (err){
        setIsSubmittingExpenseTransaction(false)
    }
  };

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value)
  }
  
  return (
    <Box>
      <h3>Expense Types</h3>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <InputBase
            placeholder="Search by Account Name"
            value={searchContent}
            onChange={handleSearchInput}
            sx={{ ml: 1, flex: 1 }}
          />
          {/* <IconButton onClick={handleClickSearch}>
            <SearchIcon />
          </IconButton> */}

          <Button variant="contained" onClick={handleClickOpen}>
            CREATE EXPENSE TYPE
          </Button>
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Expense Type Name", width: 100 },
          { label: "Description", width: 100 },
          { label: "Created By", width: 50 },
          { label: "Actions", align: "center", width: 150 },
        ]}
        rows={expenseTypesList}
        loading={isLoadingExpenseTypesList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.expense_type_name}</RCell>
            <RCell>{row.expense_type_description}</RCell>
            <RCell>{`${row.added_by.first_name} ${row.added_by.last_name}`}</RCell>
            <RCell align="center">
              <Button
                value={row.id}
                size="small"
                onClick={(e) =>handleClickOpenExpenseRecording(row.id)}
              >
                Record Expense
              </Button>
            </RCell>
          </RRow>
        )}
      />

      <FormDialog
        open={open}
        handleClose={handleClose}
        enableActions={true}
        title={"Add New Expense Type"}
        buttonText="Create Expense Type"
        handleSubmit={saveExpenseType}
        isSubmitting={isSubmittingExpenseType}
        isSubmittingText={"Creating Expense Type, Please wait..."}
        textStatus={true}
        text={`Please note that this action is going to create a new ledger called ${name} under Expenses`}
        content={
          <ExpenseTypesForm
            handleChangeName={handleChangeName}
            handleChangeDescription={handleChangeDescription}
          />
        }
      />
      <FormDialog
        open={openExpenseRecording}
        handleClose={handleCloseExpenseRecording}
        enableActions={true}
        title={"Record Expense"}
        buttonText="Save Expense"
        handleSubmit={saveExpenseTransaction}
        isSubmitting={isSubmittingExpenseTransaction}
        isSubmittingText={"Recording Expense, Please wait..."}
        textStatus={true}
        text={`Please note that this action is going to create a transaction record`}
        content={
          <ExpenseTransactionsForm
            handleChangePaymentId={handleChangePaymentId}
            handleChangeAmount={handleChangeAmount}
            handleChangeTransactionDate={handleChangeTransactionDate}
            paymentTypes={paymentTypes}
          />
        }
      />
    </Box>
  );
};
